module.exports = require("./ne-IN");